import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContentText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  DialogContent,
  TextField,
  Rating,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { deleteRequest, getRequest, patchRequest, postRequest, server } from "../../config";
import { DeleteOutline, RateReview, Visibility } from "@mui/icons-material";
import { toast } from "react-toastify";
import UserReviewsList from "./UserReviewsList";

const Service = ({ partnerId }) => {
  const [services, setservices] = useState([]);
  const [serviceId, setserviceId] = useState(null);
  const [open, setOpen] = useState(false);
  const [openAddReview, setOpenAddReview] = useState(false);
  const [openViewReview, setOpenViewReview] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [reviewForm, setReviewForm] = useState({
    rating: 5,
    comment: "",
    name: "",
  });
  function getAverageRating(totalRating) {
    if (totalRating <= 0) return 0;
    if (totalRating > 5) {
      const ratingCount = Math.ceil(totalRating / 5);
      return Number((totalRating / ratingCount)?.toFixed(2));
    } else {
      return Number(totalRating?.toFixed(2));
    }
  }

  useEffect(() => {
    fetchServices();
  }, []);
  const fetchServices = async () => {
    try {
      const uri =
        server.uri + `services?filter={"where":{"partnerId":"${partnerId}"}}`;
      const servicesData = await getRequest(uri);
      if (servicesData) setservices(servicesData);
    } catch (error) {}
  };
  const handleDeleteService = async (id) => {
    try {
      const uri = server.uri + `services/${id}`;
      const deleteService = await deleteRequest(uri);
      if (deleteService == "200") {
        setOpen(false);
      }
      await fetchServices();
    } catch (error) {}
    setOpen(false);
  };

  const handleClickOpen = (id) => {
    setserviceId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddReviewOpen = (service) => {
    setSelectedService(service);
    setReviewForm({ rating: 5, comment: "", name: "" });
    setOpenAddReview(true);
  };

  const handleAddReviewClose = () => {
    setOpenAddReview(false);
    setSelectedService(null);
  };

  const handleViewReviewOpen = (service) => {
    setSelectedService(service);
    setOpenViewReview(true);
  };

  const handleViewReviewClose = () => {
    setOpenViewReview(false);
    setSelectedService(null);
  };

  const handleSubmitReview = async () => {
    try {
      if (!selectedService?.serviceId) {
        toast.error("Service ID is required");
        return;
      }

      if (!reviewForm.name) {
        toast.error("Customer name is required");
        return;
      }

      // Create user-review
      const reviewUri = server.uri + `user-reviews`;
      await postRequest(reviewUri, {
        serviceId: selectedService.serviceId,
        serviceRequestId: "",
        customer: {
          rating: reviewForm.rating,
          comment: reviewForm.comment,
          name: reviewForm.name,
        },
      });

      // Fetch current service data
      const serviceUri = server.uri + `services/${selectedService.serviceId}`;
      const service = await getRequest(serviceUri);

      if (service) {
        // Calculate new rating
        const currentRating = service.rating || 0;
        const currentReviewCount = service.reviewCount || 0;
        const newReviewCount = currentReviewCount + 1;
        const newRating =
          (currentRating * currentReviewCount + reviewForm.rating) /
          newReviewCount;

        // Update service with new rating
        const updateUri = server.uri + `services/${selectedService.serviceId}`;
        await patchRequest(updateUri, {
          rating: parseFloat(newRating.toFixed(2)),
          reviewCount: newReviewCount,
        });

        toast.success("Review added successfully");
        handleAddReviewClose();
        fetchServices();
      }
    } catch (error) {
      console.error("Error adding review:", error);
      toast.error("Error adding review");
    }
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Services List
      </Typography>
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Services: <strong>{services?.length}</strong>
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Service"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are You Sure to Delete Service?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDeleteService(serviceId)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Paper>
        <Table>
          <TableRow
            sx={{
              backgroundColor: "#f4f6f8", // Light background for table header
            }}
          >
            <TableCell sx={{ fontWeight: "bold" }}>Service Name</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Type</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Price</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Discount</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Range</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Rating</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
          <TableBody>
            {services?.map((item) => (
              <TableRow
                sx={{
                  "&:nth-of-type(even)": {
                    backgroundColor: "#f9fafb", // Alternate row color for better readability
                  },
                }}
                key={item?.serviceId}
              >
                <TableCell>{item?.name}</TableCell>
                <TableCell>{item?.serviceType}</TableCell>
                <TableCell>{item?.categoryName}</TableCell>
                <TableCell>{item?.totalCost}</TableCell>
                <TableCell>{item?.discountPercentage}%</TableCell>
                <TableCell>{item?.city}</TableCell>
                <TableCell>{item?.range} Km</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Rating
                      value={Math.min(Number(item?.rating) || 0, 5)}
                      readOnly
                      precision={0.1}
                      size="small"
                      max={5}
                    />
                    <Typography variant="body2" fontWeight="bold">
                      {Number(item?.rating || 0).toFixed(1)}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{ display: "flex", gap: 1, flexDirection: "column" }}
                  >
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={() => handleViewReviewOpen(item)}
                      startIcon={<Visibility />}
                    >
                      View
                    </Button>
                    <Button
                      color="success"
                      variant="contained"
                      size="small"
                      onClick={() => handleAddReviewOpen(item)}
                      startIcon={<RateReview />}
                    >
                      Add Review
                    </Button>
                    <Button
                      color="error"
                      variant="contained"
                      size="small"
                      onClick={() => handleClickOpen(item?.serviceId)}
                      startIcon={<DeleteOutline />}
                    >
                      Delete
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* Add Review Dialog */}
      <Dialog
        open={openAddReview}
        onClose={handleAddReviewClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Review to {selectedService?.name}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Customer Name"
            value={reviewForm.name}
            onChange={(e) =>
              setReviewForm((prev) => ({ ...prev, name: e.target.value }))
            }
            required
          />

          <Box sx={{ mt: 2 }}>
            <Typography component="legend">Customer Rating</Typography>
            <Rating
              value={reviewForm.rating}
              onChange={(_, newValue) =>
                setReviewForm((prev) => ({
                  ...prev,
                  rating: Math.min(Math.max(newValue || 0, 0), 5),
                }))
              }
              size="large"
              max={5}
            />
          </Box>

          <TextField
            fullWidth
            margin="dense"
            label="Customer Comment"
            multiline
            rows={3}
            value={reviewForm.comment}
            onChange={(e) =>
              setReviewForm((prev) => ({ ...prev, comment: e.target.value }))
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddReviewClose}>Cancel</Button>
          <Button
            onClick={handleSubmitReview}
            variant="contained"
            color="primary"
          >
            Submit Review
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Review Dialog */}
      <Dialog
        open={openViewReview}
        onClose={handleViewReviewClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Service Details - {selectedService?.name}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Current Rating
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Rating
                value={Math.min(Number(selectedService?.rating) || 0, 5)}
                readOnly
                precision={0.1}
                size="large"
                max={5}
              />
              <Typography variant="h5" fontWeight="bold">
                {getAverageRating(selectedService?.rating)}
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Average Rating:{" "}
              <strong>  {getAverageRating(selectedService?.rating)}</strong>{" "}
              out of 5
            </Typography>
            <Typography variant="body1">
              Total Reviews:{" "}
              <strong>{selectedService?.reviewCount || 0}</strong>
            </Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              Service Information
            </Typography>
            <Typography variant="body2">
              <strong>Service ID:</strong> {selectedService?.serviceId}
            </Typography>
            <Typography variant="body2">
              <strong>Category:</strong> {selectedService?.categoryName}
            </Typography>
            <Typography variant="body2">
              <strong>Type:</strong> {selectedService?.serviceType}
            </Typography>
            <Typography variant="body2">
              <strong>Price:</strong> {selectedService?.totalCost}
            </Typography>
            <Typography variant="body2">
              <strong>Discount:</strong> {selectedService?.discountPercentage}%
            </Typography>
            <Typography variant="body2">
              <strong>City:</strong> {selectedService?.city}
            </Typography>
            <Typography variant="body2">
              <strong>Range:</strong> {selectedService?.range} Km
            </Typography>
          </Box>

          {selectedService?.serviceId && (
            <UserReviewsList serviceId={selectedService.serviceId} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewReviewClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Service;
